const userRootPath = '/users';

export const UsersNavigation = {
  PATH: userRootPath,
  add: {
    PATH: `${userRootPath}/add`,
    RELATIVE: 'add',
  },
  edit: {
    PATH: `${userRootPath}/:userId`,
    url: (userId: string) => `${userRootPath}/${userId}`,
    RELATIVE: ':userId',
  },
} as const;
